import React from 'react'
import Modal from 'react-bootstrap/Modal';
import { ModalHeader } from 'reactstrap';
import AmountFormatter from '../../../../utils/AmountFormatter';

const PatAdvancePaymentConfirmation = ({ isOpenPatAdvPayment, closePatAdvPayentConf, onProceddPatAdvPayentConf, AdvancePayment }) => {
    return (
        <Modal show={isOpenPatAdvPayment} onHide={closePatAdvPayentConf} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar_export-excel_popup advance-pat-payment">
            <Modal.Body>
                <div className="d-flex justify-content-between align-items-center mb-12">
                    <p className="heading dark-clr fs-14">Use Advance Payment?</p>
                    <i className="icon-x-cros fs-20 dark-clr" onClick={closePatAdvPayentConf}></i>
                </div>
                <div className='ar-alert d-flex mb-1'>
                    <i className='icon-alert mt-1'></i>
                        <p className="text ms-1">Patient has <span className='font-sb'>{`$${AdvancePayment}`}</span> as advance payment. Would you like to use that?</p>
                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={closePatAdvPayentConf}>No</button>
                <button className='btn btn-validate px-10 h-100' onClick={() => onProceddPatAdvPayentConf()}>Yes</button>
            </div>
            <div>
            </div>
        </Modal >
    )
}

export default PatAdvancePaymentConfirmation